import Main from "../components/Main";
import { Panel} from "../components/Panel";
import Header from "../components/Hearder";
import {StyledContent}  from '../styled/StyledContent'

function App() {
  return(
    <div> 
      <StyledContent>
        <Header/>
          <Main>
          <Panel/>
          </Main>
      </StyledContent>
    </div>
  )
}

export default App;

